import { Button } from "primereact/button";
import './styles/link_style.css';
const LinkComponent = (props) => {
    return (
        <Button link {...props} className="text-white" />
    );
};

export default LinkComponent;